module.exports = __webpack_public_path__ + "static/img/menuLogo.aa35c07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menuLogo.png
// module id = IuJo
// module chunks = 5